import { render, staticRenderFns } from "./PsPatientRefundDetail.vue?vue&type=template&id=4f14af9e&scoped=true&"
import script from "./PsPatientRefundDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientRefundDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientRefundDetail.vue?vue&type=style&index=0&id=4f14af9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f14af9e",
  null
  
)

export default component.exports